module.exports = __webpack_public_path__ + "img/step49_down.8bdaf147.png";